import React from 'react';
import './VehicleFeatures.css';

const VehicleFeatures = ({ features }) => {
  const iconMap = {
    passengers: '👥',
    doors: '🚪',
    transmission: '⚙️',
    airConditioning: '❄️',
    luggage: '🧳',
    abs: '🛡️',
    unlimited: '∞'
  };

  return (
    <div className="vehicle-features">
      {features.passengers && (
        <div className="feature">
          <span className="feature-icon">{iconMap.passengers}</span>
          <span className="feature-value">{features.passengers}</span>
        </div>
      )}
      {features.doors && (
        <div className="feature">
          <span className="feature-icon">{iconMap.doors}</span>
          <span className="feature-value">{features.doors}</span>
        </div>
      )}
      {features.transmission && (
        <div className="feature">
          <span className="feature-icon">{iconMap.transmission}</span>
          <span className="feature-value">{features.transmission}</span>
        </div>
      )}
      {features.airConditioning && (
        <div className="feature">
          <span className="feature-icon">{iconMap.airConditioning}</span>
        </div>
      )}
      {features.luggage && (
        <div className="feature">
          <span className="feature-icon">{iconMap.luggage}</span>
          <span className="feature-value">{features.luggage}</span>
        </div>
      )}
      {features.abs && (
        <div className="feature">
          <span className="feature-icon">{iconMap.abs}</span>
          <span className="feature-text">ABS</span>
        </div>
      )}
      {features.unlimited && (
        <div className="feature">
          <span className="feature-icon">{iconMap.unlimited}</span>
          <span className="feature-text">Kilómetros ilimitados</span>
        </div>
      )}
    </div>
  );
};

export default VehicleFeatures;
